import { render } from "./App.vue?vue&type=template&id=b949ef60"
const script = {}

import "./App.vue?vue&type=style&index=0&id=b949ef60&lang=scss"

import exportComponent from "V:\\Personal\\Projects\\Code\\Emotion-Based-Music-Streaming-App-WEB\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__